import useEditMotorcycle from 'modules/delivery-men/hooks/use-edit-motorcycle';
import {
  MotorcycleProps,
  translatedMotorcycleProps,
} from 'modules/delivery-men/types';
import deliveryMenKeys from 'modules/delivery-men/util/delivery-men-keys';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditMotorcycle: React.FC = () => {
  const {id} = useParams();
  const {getInput} = useFormInputs<MotorcycleProps>();

  return (
    <Edition<MotorcycleProps>
      inputs={[
        getInput({name: 'plate'}),
        getInput({name: 'model'}),
        getInput({name: 'brand'}),
        getInput({name: 'year'}),
      ]}
      handleDefaultValues={(data) => data?.user?.motorcycle}
      detailsUrl={`/access-controls/${id}`}
      onSubmit={() => useEditMotorcycle(id!)}
      translationKey={translatedMotorcycleProps}
      queryKey={deliveryMenKeys.details(id!)}
    />
  );
};

export default EditMotorcycle;
